<template>
    <div class="thumbnail-wrapper">
        <img
            :src="props.thumbnailUrl"
            alt=""
            loading="lazy"
            decoding="async"
            fetchpriority="low"
            v-if="props.thumbnailUrl"
            @error="e => handleImageError(e)"
            :style="{ objectPosition: metadata.thumbnailObjectPosition ?? 'top center' }"
            class="thumbnail" />
    </div>
</template>

<script lang="ts" setup>
import { ReportType } from '@/interfaces/deltaGpt/IDocument.ts';
import { getReportTypeMetadata } from '@/utils/researchContent.ts';

const props = defineProps<{ thumbnailUrl: string; reportType: ReportType }>();

const metadata = getReportTypeMetadata(props.reportType);

function handleImageError (e: Event): void {
    const img = e.target as HTMLImageElement | null;
    if (!img) return;

    img.src = metadata.fallbackThumbnail;
}

</script>

<style lang="scss" scoped>

.thumbnail-wrapper {
    width: 18rem;
    height: 10rem;
    overflow: hidden;

    .thumbnail {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border: 1px solid var(--neutral300);
        border-radius: var(--borderRadiusOuter);
        display: block;
    }
}
</style>
